import { render, staticRenderFns } from "./ListadoInscripcionesProgramaUniversidad.vue?vue&type=template&id=5e65d41e"
import script from "./ListadoInscripcionesProgramaUniversidad.vue?vue&type=script&lang=js"
export * from "./ListadoInscripcionesProgramaUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ListadoInscripcionesProgramaUniversidad.vue?vue&type=style&index=0&id=5e65d41e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports